import { exitoTenant } from '@segurosvoluntarios_vel/commons-services';
import { PagoTenant } from 'src/app/pago/models/PagoTenant.model';

export const EXITO_TENANT: PagoTenant = {
  ...exitoTenant,
  properties: {
    ...exitoTenant.properties,
    // new variable
    '--primary-color-payment': '#008bce',
    //Header
    '--bg-sub-menu': 'var(--primary)',
    // breadcrumbs
    '--color-breadcrumb-success': 'var(--secondary)',
    '--breadcrumb-selected-color': 'var(--primary)',
    '--breadcrumb-text-color-active': 'var(--primary)',
    // button back payment
    '--color-text-back-payment': 'var(--secondary)',
    // tabs methods payment
    '--bg-color-tab-method-payment': '#f2f2f2',
    '--text-color-tab-method-payment': 'var(--secondary)',
    '--border-color-tab-method-payment': 'var(--secondary)',
    '--bg-color-tab-method-payment-active': 'var(--secondary)',
    '--border-color-tab-method-payment-active': 'var(--secondary)',
    '--text-color-tab-method-payment-active': '#fff',
    // '--bg-another-payments-methods': 'var(--secondary)',
    // body methods payment
    '--body-border-color-method-payment': 'var(--secondary)',
    //content purchase
    '--bg-color-content-purchase': '#fafafa',
    // '--box-shadow-content-purchase': 'none',
    //title resume
    '--text-color-title-resume-purchase': 'var(--secondary)',
    '--font-size-title-resume-purchase': '21px',
    '--border-color-title-resume-purchase': 'var(--secondary)',
    '--margin-title-resume-purchase': '0 0 1.3rem 0',
    // list resume
    '--text-color-list-resume-purchase-key': 'var(--secondary)',
    '--font-size-list-resume-purchase': '1rem',
    // separate resume
    '--bg-color-separate-purchase': 'var(--secondary)',
    // total payment resume
    '--text-color-total-resume-purchase': 'var(--secondary)',
    //botton payment
    '--bg-color-switche-slider': 'red',
    '--color-button-comprar': 'var(--secondary)',
    '--bg-color-button-comprar': '#ffe900',
    //Other values
    '--primary-color-pago': '#003764',
    '--secondary-color-pago': '#00448d',
    '--bg-color-tab-medio-pago': '#fff',
    '--color-tab-medio-pago-active': '#fff',
    '--color-border-bottom-tabs': 'var(--primary)',
    '--border-color-tab-content': '#fff',
    '--box-shadow-resumen-compra': '0',
    '--color-key-resumen-compra': '#000',
    '--border-radius-button-comprar': '3.125rem',
    '--color-icono-estado-pago-aprobado': '#00448D',
    '--color-estado-pago-aprobado': '#00448D',
    '--bg-color-button-regresar-al-comercio': 'var(--bg-color-button-comprar)',
    '--color-button-regresar-al-comercio': 'var(--color-button-compra)',
    '--bg-hover-color-button-submit-payment': 'var(--secondary)',
  },
};
